import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Confirmacao } from './confirmacao';

@Component({
  selector: 'confirmacao.dialog',
  templateUrl: './confirmacao.dialog.html'
})
export class ConfirmacaoDialog {
    public isLoading: boolean;
    public mensagem: string;
    public mostrarOk: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<ConfirmacaoDialog>,
    @Inject(MAT_DIALOG_DATA) public confirmacao: any) {
      this.mensagem = confirmacao.mensagem;
      if(confirmacao.mostrarOk){
        this.mostrarOk = true;
      }
    }


  sim(): void {
      this.dialogRef.close(true);
  }

  nao(): void {
      this.dialogRef.close(false);
    }


}
